import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showSyncPopup: false,
  syncTaskId: null,
  syncSource: null,
};

const syncSlice = createSlice({
  name: "sync",
  initialState,
  reducers: {
    setSyncPopupState: (state, action) => {
      state.showSyncPopup = action.payload.show;
      state.syncTaskId = action.payload.taskId;
      state.syncSource = action.payload.syncSource || null;
    },
    closeSyncPopup: (state) => {
      state.showSyncPopup = false;
    },
    resetSyncState: (state) => {
      state.showSyncPopup = false;
      state.syncTaskId = null;
      state.syncSource = null;
    },
  },
});

export const { setSyncPopupState, closeSyncPopup, resetSyncState } =
  syncSlice.actions;
export default syncSlice.reducer;
